import {
  EasyPostCarrierType,
  EasypostOAuthStatus,
  ICarrierAccount,
  UspsOAuthStatus,
} from "@redotech/redo-fulfillment-rate-common/carrier-account";
import { RateProvider } from "@redotech/redo-fulfillment-rate-common/outbound-labels";

export function carrierAccountNeedsAuthentication(
  carrierAccount: ICarrierAccount,
): boolean {
  return (
    (carrierAccount.provider === RateProvider.EASYPOST &&
      !!carrierAccount.oauthUrl &&
      carrierAccount.oauthStatus !== EasypostOAuthStatus.APPROVED) ||
    (carrierAccount.provider === RateProvider.FEDEX &&
      !carrierAccount.authenticated) ||
    (carrierAccount.provider === RateProvider.USPS &&
      carrierAccount.oauthStatus !== UspsOAuthStatus.APPROVED)
  );
}

export function carrierAccountNeedsEasypostFedexMfa(
  carrierAccount: ICarrierAccount,
): boolean {
  return (
    carrierAccount.provider === RateProvider.EASYPOST &&
    (carrierAccount.easypostCarrierType === EasyPostCarrierType.FEDEX ||
      carrierAccount.easypostCarrierType ===
        EasyPostCarrierType.FEDEX_SMARTPOST) &&
    !carrierAccount.mfaComplete
  );
}

/** Whether the merchant still has to finish an OAuth or MFA step before the account can rate. */
export function carrierAccountAwaitingAuthorization(
  carrierAccount: ICarrierAccount,
): boolean {
  return (
    carrierAccountNeedsAuthentication(carrierAccount) ||
    carrierAccountNeedsEasypostFedexMfa(carrierAccount)
  );
}
